import { createSlice } from "@reduxjs/toolkit";
import {
  createVendorTagMapping,
  deleteVendorTagMappingApi,
  fetchVendorTagMappings,
  updateVendorTagMappingApi,
} from "../Thunks/vendorTagMappingThunk";
import { addAsyncResourceThunk, applySaveRejected } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
  saving: false,
  saveError: null,
};

export const vendorTagMappingSlice = createSlice({
  name: "vendorTagMapping",
  initialState,
  reducers: {
    clearVendorTagMappings: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchVendorTagMappings);
    builder
      .addCase(createVendorTagMapping.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(createVendorTagMapping.fulfilled, (state) => {
        state.saving = false;
        state.saveError = null;
      })
      .addCase(createVendorTagMapping.rejected, (state, action) => {
        applySaveRejected(state, action, "Failed to create vendor tag mapping");
      })
      .addCase(updateVendorTagMappingApi.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(updateVendorTagMappingApi.fulfilled, (state) => {
        state.saving = false;
        state.saveError = null;
      })
      .addCase(updateVendorTagMappingApi.rejected, (state, action) => {
        applySaveRejected(state, action, "Failed to update vendor tag mapping");
      })
      .addCase(deleteVendorTagMappingApi.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(deleteVendorTagMappingApi.fulfilled, (state) => {
        state.saving = false;
        state.saveError = null;
      })
      .addCase(deleteVendorTagMappingApi.rejected, (state, action) => {
        applySaveRejected(state, action, "Failed to delete vendor tag mapping");
      });
  },
});

export const { clearVendorTagMappings } = vendorTagMappingSlice.actions;

export const selectVendorTagMappingData = (state) => state.vendorTagMapping.data;
export const selectVendorTagMappingLoading = (state) => state.vendorTagMapping.loading;
export const selectVendorTagMappingError = (state) => state.vendorTagMapping.error;
export const selectVendorTagMappingSaving = (state) => state.vendorTagMapping.saving;
export const selectVendorTagMappingSaveError = (state) => state.vendorTagMapping.saveError;

export default vendorTagMappingSlice.reducer;
